import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import PropTypes from 'prop-types';

const CustomDropDown = ({ name, value, onChange, error, errorMessage, options, placeholder }) => {
  return (
    <div className="flex flex-column padding_0">
      <Dropdown
        name={name}
        value={value}
        onChange={onChange}
        className={error ? 'p-invalid' : ''}
        placeholder={placeholder}
        options={options}
      />
      {error && (
        <p className="align-self-start" style={{ color: 'red', marginTop: '5px' }}>
          {errorMessage}
        </p>
      )}
    </div>
  );
};

CustomDropDown.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  error: PropTypes.string,
  errorMessage: PropTypes.string,
};

CustomDropDown.defaultProps = {
  error: undefined,
  errorMessage: undefined,
};

export default CustomDropDown;
